import { columnDefinitions, type ColumnKey } from './definitions'

const sharedKeys: ColumnKey[] = [
    'candidate',
    'status',
    'colors',
    'favorited',
    // 'actions',
    'processStatus',
    'dateAdded',
    'processStatusUpdatedAt',
    'internalNote',
]

const preMbaKeys: ColumnKey[] = [
    'currentCompany',
    'currentTitle',
    'currentIndustry',
    'currentSector',
    'currentSectorDescription',
    'currentLocation',
    'startDate',
    'undergradEducation',
    'undergradYear',
    'undergradGpa',
    'sat',
    'act',
    'hometown',
    'analystClassYear',
    'gender',
    'ethnicity',
    'visaStatus',
    'preAdmitAttribute',
    'starRatingMostRecentScreen',
    'starRatingReference',
    'referenceAttribute',
    'rosterLocationFromBlast',
    'rosterSectorFromBlast',
    'rosterInterestFromBlast',
    'rosterNotInterestedReasonFromBlast',
    'rosterCommentsFromBlast',
    'recruitingIndustryPref1',
    'recruitingIndustryPref2',
    'recruitingSectorPref1',
    'recruitingSectorPref2',
    'recruitingGeoPref1',
    'recruitingGeoPref2',
    'ccatRawScore',
    'ccatPercentile',
    'sourceStatus',
    'email',
    'linkedinUrl',
    'resumeUrl',
    'resumeUpdatedDate',
    'candidateProfileUrl',
]

const postMbaKeys: ColumnKey[] = [
    'currentCompany',
    'currentTitle',
    'currentIndustry',
    'currentLocation',
    'currentSector',
    'currentSectorDescription',
    'startDate',
    'gender',
    'ethnicity',
    'visaStatus',
    'sourceStatus',
    'cpiPlaced',
    'undergradEducation',
    'undergradYear',
    'mbaEducation',
    'mbaYear',
    'undergradGpa',
    'sat',
    'act',
    'gmat',
    'previousCompany',
    'previousIndustry',
    'previousSector',
    'recruitingGeoPref1',
    'recruitingGeoPref2',
    'recruitingGeoPref3',
    'mbaTiering',
    'email',
    'recruitingSectorPref1',
    'recruitingSectorPref2',
    'recruitingSectorPref3',
    'hometown',
    'phone',
    'publicBio',
]

const portOpsKeys: ColumnKey[] = [
    'sourceStatus',
    'starRatingMostRecentScreen',
    'starRatingReference',
    'currentCompany',
    'currentTitle',
    'currentIndustry',
    'currentSector',
    'startDate',
    'currentLocation',
    'undergradEducation',
    'undergradYear',
    'undergradGpa',
    'gender',
    'visaStatus',
    'ethnicity',
    'resumeUrl',
    'resumeUpdatedDate',
    'previousTitle',
    'previousIndustry',
    'previousSector',
    'previousStartDate',
    'mbaYear',
    'mbaEducation',
    'preferredEmail',
    'email',
]

const allKeys: ColumnKey[] = [
    'sourceStatus',
    'rosterInterestFromBlast',
    'rosterNotInterestedReasonFromBlast',
    'rosterCommentsFromBlast',
    'rosterLocationFromBlast',
    'rosterSectorFromBlast',
    'currentCompany',
    'currentTitle',
    'currentIndustry',
    'currentLocation',
    'currentSector',
    'currentSectorDescription',
    'startDate',
    'gender',
    'ethnicity',
    'visaStatus',
    'cpiPlaced',
    'undergradEducation',
    'undergradYear',
    'undergradGpa',
    'sat',
    'act',
    'gmat',
    'hometown',
    'analystClassYear',
    'recruitingIndustryPref1',
    'recruitingIndustryPref2',
    'recruitingSectorPref1',
    'recruitingSectorPref2',
    'recruitingGeoPref1',
    'recruitingGeoPref2',
    'starRatingAvg',
    'starRatingMostRecentScreen',
    'starRatingReference',
    'referenceAttribute',
    'preAdmitAttribute',
    'email',
    'preferredEmail',
    'phone',
    'resumeUrl',
    'resumeUpdatedDate',
    'linkedinUrl',
    'candidateProfileUrl',
]

export const preMbaColumns = [...sharedKeys, ...preMbaKeys].map(
    (k) => columnDefinitions[k]
)
export const postMbaColumns = [...sharedKeys, ...postMbaKeys].map(
    (k) => columnDefinitions[k]
)
export const portOpsColumns = [...sharedKeys, ...portOpsKeys].map(
    (k) => columnDefinitions[k]
)
export const allColumns = [...sharedKeys, ...allKeys].map(
    (k) => columnDefinitions[k]
)
